import React from "react";
import SVG_POINTER from "../../../assets/images/vector/components/common/pointer.svg";
import PNG_HELP from "../../../assets/images/raster/pages/es/Support/help@2x.png";
import WEBP_HELP from "../../../assets/images/raster/pages/es/Support/help@2x.webp";
import Container from "../../common/UI/Container";
import "./index.scss";

const POINTS_TEXT = [
  "Problemas técnicos durante el registro, instalación y uso de las herramientas de AMZScout",
  "Preguntas prácticas sobre el contenido e interpretación de los datos obtenidos durante el proceso de investigación utilizando nuestras herramientas",
];

const STATIC_POINTS_TEXT = POINTS_TEXT.map((text, i) => (
  <li key={text} className="PgESM-S-points">
    <img className="PgESM-S-points__pointer" src={SVG_POINTER} alt="-" />
    <p className="PgESM-S-points__text">{text}</p>
  </li>
));

const Support = () => (
  <section className="PgESM-S">
    <Container mode="standard">
      <h2 className="PgESM-S__title">
        Obtén asistencia amigable y útil las 24 horas con las herramientas de
        AMZScout
      </h2>
      <div className="PgESM-S-content">
        <div className="PgESM-S-info">
          <p className="PgESM-S-info__title">
            Si te atascas usando cualquiera de nuestras herramientas y
            servicios, no tienes que resolverlo solo. Estamos aquí para ayudarte
            con cualquiera de lo siguiente:
          </p>
          <ul className="PgESM-S-info-list">{STATIC_POINTS_TEXT}</ul>
        </div>
        <div className="PgESM-S-S">
          <picture>
            <source type="image/webp" srcSet={WEBP_HELP} />
            <img
              src={PNG_HELP}
              className="PgESM-S-S__img"
              alt="img"
              loading="lazy"
            />
          </picture>
        </div>
      </div>
    </Container>
  </section>
);

export default Support;
